import { ArrowUpRightIcon } from "@heroicons/react/24/solid";
import clsx from "clsx";
import React from "react";

export default function DashboardCompletionStepBox({
  iconFilename,
  icon,
  title,
  description,
  status,
  isDimmed = false,
}: {
  iconFilename?: string;
  icon?: React.ReactNode;
  title: string;
  description: string;
  status: "complete" | "finish-set-up" | "in-progress" | "disabled";
  isDimmed?: boolean;
}) {
  return (
    <div className="tw-boundary">
      <div
        className={clsx(
          "max-w-[407px] rounded-[8px] border-[1.5px] border-neutral-400 p-[24px] hover:border-primary-600",
          { "opacity-50": isDimmed },
        )}
      >
        <div className="flex flex-col justify-between">
          <div className="flex justify-between">
            <div className="h-[48px] w-[48px] flex items-center justify-center">
              {icon ? icon : <img src={iconFilename} alt="icon" className="h-[48px] w-[48px]" />}
            </div>
            <div>{status !== "disabled" && <ArrowUpRightIcon className="h-[24px] w-[24px]" />}</div>
          </div>
          <div className="flex justify-between">
            <div className="text-[18px] text-gray-900">{title}</div>
            {status !== "disabled" && !isDimmed && <StatusBadge status={status} />}
          </div>
          <div className="text-[14px] text-neutral-900">{description}</div>
        </div>
      </div>
    </div>
  );
}

const StatusBadge = ({
  status,
}: {
  status: "complete" | "finish-set-up" | "in-progress" | "disabled";
}) => {
  if (status === "complete") {
    return (
      <div className="flex items-center justify-center bg-[#9DE3C7] font-medium text-green-800 px-[8px] py-[1.5px] rounded-[100px] h-[32px] max-w-[93px] text-[14px]">
        Completed
      </div>
    );
  } else if (status === "finish-set-up") {
    return (
      <div className="flex items-center justify-center bg-amber-100 font-medium text-amber-800 px-[8px] py-[1.5px] rounded-[100px] h-[32px] max-w-[107px] text-[14px]">
        Finish Set Up
      </div>
    );
  } else if (status === "in-progress") {
    return (
      <div className="flex items-center justify-center bg-blue-100 font-medium text-blue-800 px-[8px] py-[1.5px] rounded-[100px] h-[32px] max-w-[100px] text-[14px]">
        In Progress
      </div>
    );
  } else {
    return null;
  }
};
